<template>
    <div class="timers">
        <button v-for="index in length" :key="index" class="timer" @click="() => slideTo(index - 1)">
            <div class="timer-number">0{{ index }}</div>
            <div class="progress-bar">
                <div :class="{progress: true, progressing: currentSlide == index - 1, done: currentSlide > index - 1}" />
            </div>
        </button>
    </div>
</template>
<script setup lang="ts">
    defineProps<{length: number; currentSlide: number; slideTo: (index: number) => void}>();
</script>
